<template>
    <div class="question">
        <div class="questionnaire">
            <h1>新增问卷</h1>
            <div class="question_bd">
                <em><b>*</b>问卷标题:</em><el-input v-model="title" placeholder="请输入标题" class="question_title"></el-input>
                <div class="clear"></div>
                <em><b>*</b>选择分类:</em>
                <el-dropdown  class="rf dropselect questionView" trigger="click">
                    <span class="el-dropdown-link">
                    请选择分类<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>黄金糕</el-dropdown-item>
                        <el-dropdown-item>狮子头</el-dropdown-item>
                        <el-dropdown-item>螺蛳粉</el-dropdown-item>
                        <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                        <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div class="clear"></div>
                <em><b>*</b>问卷描述:</em><el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea" class="question_textarea" resize='none'></el-input>
               
            </div>
            <div class="drop_draw">
                <span>请点击右侧控件添加字段</span>
            </div>
             <div class="question_com" v-for="(item,index) in questionList">
                <div class="question_list questionRadio" v-if="item.type==1">
                    <h3>单选</h3>
                    <el-radio-group v-model="radio">
                        <el-radio :label="i" v-for="(i,a) in item.radio" :key='a'></el-radio>
                    </el-radio-group>
                    <em @click="addRadio(index)">添加新选项</em>
                    <div class="question_center">
                        <el-checkbox v-model="checked">必填</el-checkbox>
                        <el-popover
                            placement="top"
                            class="btnTc rf"
                            popper-class="tcBtn"
                            width="160"
                            v-model="visible"
                            >
                            <p>确定删除试题吗？</p>
                        <div style="margin: 20px 0 0">
                            <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
                            <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                        </div>
                        <el-button slot="reference">删除</el-button>
                        </el-popover>
                    </div>
                </div>
                <div class="question_list questionStart" v-if="item.type==4">
                    <h3>评分</h3>
                    <el-rate v-model="item.start"  :colors="color" class="question_start"></el-rate>
                    <div class="question_center">
                        <el-checkbox v-model="checked">必填</el-checkbox>
                        <el-popover
                            placement="top"
                            class="btnTc rf"
                            popper-class="tcBtn"
                            width="160"
                           >
                            <p>确定删除试题吗？</p>
                        <div style="margin: 20px 0 0">
                            <el-button type="primary" size="mini" >确定</el-button>
                            <el-button size="mini" type="text" >取消</el-button>
                        </div>
                        <el-button slot="reference">删除</el-button>
                        </el-popover>
                    </div>
                </div>
                <div class="question_list questionCheck" v-if="item.type==2">
                    <h3>多选</h3>
                     <el-checkbox-group 
                        v-model="checkedCities" class="question_check">
                        <el-checkbox v-for="(i,a) in item.check" :label="i" :key="a">{{i}}</el-checkbox>
                    </el-checkbox-group>
                    <em @click="addcheck(index)">添加新选项</em>
                    <div class="question_center">
                        <el-checkbox v-model="checked">必填</el-checkbox>
                        <el-popover
                            placement="top"
                            class="btnTc rf"
                            popper-class="tcBtn"
                            width="160"
                            >
                            <p>确定删除试题吗？</p>
                        <div style="margin: 20px 0 0">
                            <el-button type="primary" size="mini" >确定</el-button>
                            <el-button size="mini" type="text" >取消</el-button>
                        </div>
                        <el-button slot="reference">删除</el-button>
                        </el-popover>
                    </div>
                </div>
                <div class="question_list questionTextarea" v-if="item.type==3">
                    <h3>输入框</h3>
                     <el-input
                        type="textarea"
                        resize='none'
                        :row="1"
                        placeholder="请输入内容"
                        v-model="answerText">
                    </el-input>
                    <em>添加新选项</em>
                    <div class="question_center">
                        <el-checkbox v-model="checked">必填</el-checkbox>
                        <el-popover
                            placement="top"
                            class="btnTc rf"
                            popper-class="tcBtn"
                            width="160"
                            >
                            <p>确定删除试题吗？</p>
                        <div style="margin: 20px 0 0">
                            <el-button type="primary" size="mini" >确定</el-button>
                            <el-button size="mini" type="text" >取消</el-button>
                        </div>
                        <el-button slot="reference">删除</el-button>
                        </el-popover>
                    </div>
                </div>
            </div>
        </div>
        <div class="questionnaire_footer">
            <button class="btn_suceess">查看</button>
            <button class="btn_suceess">存草稿</button>
            <button class="btn_suceess">发布</button>
            <button>取消</button>
        </div>
        <div class="common_zj">
            <h2>通用组件</h2>
            <ul>
                <li @click="addquestion(1)"><img src="/static/img/dx.png" > <p>单选</p></li>
                <li @click="addquestion(2)"><img src="/static/img/dbx.png" ><p>多选</p></li>
                <li @click="addquestion(3)"><img src="/static/img/ip.png" ><p>输入框</p></li>
                <li @click="addquestion(4)"><img src="/static/img/start.png" ><p>评分</p></li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default{
        name:'questionnaire',
         data() {
            return {
                title:'', 
                visible: false,
                textarea:'',   
                checked:'',
                answerText:'',
                radio:'',
                color:['#55ACEF','#55ACEF','#55ACEF'],
                questionList:[],
                checkedCities:[]
            };
        },
        methods:{
            addquestion(i){
                if(i==1){
                    this.questionList.push({'type':i,'radio':[]})
                }  
                else if(i==2){
                    this.questionList.push({'type':i,'check':[]})
                }  
                else if(i==3){
                    this.questionList.push({'type':i,'answerText':''})
                }   
                else if(i==4){
                    this.questionList.push({'type':i,'start':''})
                }  
            },
            addRadio(i){
                let a =  this.questionList[i].radio.length+1;
                this.questionList[i].radio.push('选项'+a)
            },
            addcheck(i){
                let a =  this.questionList[i].check.length+1;
                this.questionList[i].check.push('选项'+a)
            }
        },
        mounted(){
        }
    }
</script>
<style>
   @import "../../assets/css/questionnaire.css";
</style>


// WEBPACK FOOTER //
// src/components/questionnaire/questionnaire.vue